export default __webpack_public_path__ + "static/media/1020.8cab5511.png";